import { ChangeEventHandler, FC, useRef, useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import { makeStyles } from "./styles";
import { Scribble } from "./store";

interface ScribbleInlineEditorProps {
    scribble: Scribble;
    onSave: (value: string) => void;
    onCancel: () => void;
}

export const ScribbleInlineEditor: FC<ScribbleInlineEditorProps> = ({ scribble, onSave, onCancel }) => {
    const [textareaText, setTextareaText] = useState("");
    const ref = useRef<HTMLTextAreaElement | null>(null);
    const { classes, cx } = useStyles();

    useEffect(() => {
        setTextareaText(scribble.text);
        ref.current?.focus();
    }, [scribble]);

    const onTextareaChange: ChangeEventHandler<HTMLTextAreaElement> = (event) => {
        setTextareaText(event.target.value);
    };

    return (
        <>
            <div className={classes.clickAway} onClick={onCancel} />
            <Card className={cx(classes.ScribbleEditor, "shadow")}>
                <Card.Body className={classes.body}>
                    <textarea
                        ref={ref}
                        className={classes.textArea}
                        value={textareaText}
                        onChange={onTextareaChange}
                        spellCheck="false"
                    />
                    <div className={classes.buttons}>
                        <Button onClick={() => onSave(textareaText)}>Save</Button>
                        <Button onClick={onCancel}>Cancel</Button>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

const useStyles = makeStyles()((theme, _params, classes) => ({
    ScribbleEditor: {
        position: "absolute",
        top: -1,
        right: -2,
        bottom: "-4rem",
        left: 0,
        zIndex: 1,
        transform: "translateX(-1px)",
    },
    clickAway: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, .2)",
    },
    body: {
        display: "flex",
        flexDirection: "column",
    },
    textArea: {
        textAlign: "right",
        flex: 1,
        border: 0,
        outline: 0,
        padding: "3px 0 0 0",
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: theme.space,
        gap: theme.space,
    },
}));
